
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Step1 from "@/views/pages/application/subject/steps/Step1.vue";
import Step2 from "@/views/pages/application/subject/steps/Step2.vue";
import Step3 from "@/views/pages/application/subject/steps/Step3.vue";
import Step4 from "@/views/pages/application/subject/steps/Step4.vue";
import Step5 from "@/views/pages/application/subject/steps/Step5.vue";

import Step6 from "@/views/pages/application/subject/steps/Step6.vue";
import { StepperComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { useForm } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";
import { useToast } from "vue-toastification";
import NoteSection from "@/components/sections/NoteSection.vue";

interface IStep1 {
  q1_1: string;
  q1_2: string;
  q1_3: string;
}

interface IStep2 {
  q2_1: string;
  q2_2: string;
  q2_3: string;
  q2_4: string;
  q2_5: string;
  q2_6: string;
  q2_7: string;
  q2_8: string;
  q2_9: string;
  q2_10: string;
  q2_11: string;
  q2_12: string;
  q2_13: string;
  q2_14: string;
  q2_populationOther: string;
}

interface IStep3 {
  q3_1: string;
  q3_2: string;
}

interface IStep4 {
  q4_1: string;
  q4_2: string;
}

interface IStep5 {
  q5_1: string;
  q5_2: string;
  q5_3: string;
  q5_4: string;
  q5_5: string;
  q5_6: string;
  q5_7: string;
}
  
interface CreateAccount extends IStep1, IStep2, IStep3, IStep4, IStep5 {}

export default defineComponent({
  name: "kt-vertical-wizard",
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    NoteSection,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const toast = useToast();

    const _stepperObj = ref<StepperComponent | null>(null);
    const verticalWizardRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(1);
    const jumped = ref(0);
    const fromJumpled = ref(0);
    const previewStep = ref(0);

    const currentSubject = computed(() => {
      return store.getters.currentSubject;
    });

    let formData = ref<CreateAccount>({
      q1_1: currentSubject.value.data
        ? currentSubject.value.data.numSubRecruited
        : "",
      q1_2: currentSubject.value.data
      ? currentSubject.value.data.researchSubject
      : "",
      q1_3: currentSubject.value.data
      && currentSubject.value.data.isIncludeGannonStudents == true?
      "1": "0",
      q2_1: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>1
      && currentSubject.value.data.population[1].isChecked
         ? "1" : "0",
      q2_2: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>2
        && currentSubject.value.data.population[2].isChecked
         ? "1" : "0",
      q2_3: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>3
        && currentSubject.value.data.population[3].isChecked
         ? "1" : "0",
      q2_4: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>4
        && currentSubject.value.data.population[4].isChecked
         ? "1" : "0",
      q2_5: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>5
        && currentSubject.value.data.population[5].isChecked
         ? "1" : "0",
      q2_6: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>6
        && currentSubject.value.data.population[6].isChecked
         ? "1" : "0",
      q2_7: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>7
        && currentSubject.value.data.population[7].isChecked
         ? "1" : "0",
      q2_8: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>8
        && currentSubject.value.data.population[8].isChecked
         ? "1" : "0",
      q2_9: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>9
        && currentSubject.value.data.population[9].isChecked
         ? "1" : "0",
      q2_10: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>10
        && currentSubject.value.data.population[10].isChecked
         ? "1" : "0",
      q2_11: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>11
        && currentSubject.value.data.population[11].isChecked
         ? "1" : "0",
         q2_12: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>12
        && currentSubject.value.data.population[12].isChecked
         ? "1" : "0",
         q2_13: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>13
        && currentSubject.value.data.population[13].isChecked
         ? "1" : "0",
         q2_14: currentSubject.value.data  && currentSubject.value.data.population  && currentSubject.value.data.population.length>14
        && currentSubject.value.data.population[14].isChecked
         ? "1" : "0",
         q2_populationOther: currentSubject.value.data  != null
         ? currentSubject.value.data.populationOther: "",
      
      q3_1: currentSubject.value.data && currentSubject.value.data.inclusionCriterial != null? 
        currentSubject.value.data.inclusionCriterial : "",
      q3_2: currentSubject.value.data &&  currentSubject.value.data.exclusionCriterial != null? 
        currentSubject.value.data.exclusionCriterial : "",
      
      q4_1: currentSubject.value.data && currentSubject.value.data.subjectLocation != null? 
        currentSubject.value.data.subjectLocation : "",
      q4_2: currentSubject.value.data &&  currentSubject.value.data.subRecruitedOther != null? 
        currentSubject.value.data.subRecruitedOther : "",

      q5_1: currentSubject.value.data
        && currentSubject.value.data.isAvailableEveryOne == true
         ? "1" : "0",
      q5_2: currentSubject.value.data  
      && currentSubject.value.data.confidentialityExplanation != null
         ? currentSubject.value.data.confidentialityExplanation : "",
      q5_3: currentSubject.value.data  && currentSubject.value.data.subjectConfidentiality != null
         ? currentSubject.value.data.subjectConfidentiality  : "",
      q5_4: currentSubject.value.data 
        && currentSubject.value.data.isInformationIdentifiable == true
         ? "1" : "0",
      q5_5: currentSubject.value.data  && currentSubject.value.data.whatIdentifiers != null
      ? currentSubject.value.data.whatIdentifiers  : "",
      q5_6: currentSubject.value.data  && currentSubject.value.data.whoHaveAccess != null
      ? currentSubject.value.data.whoHaveAccess  : "",
      q5_7: currentSubject.value.data  && currentSubject.value.data.whenIdentifyData != null
      ? currentSubject.value.data.whenIdentifyData  : "",
    });

    onMounted(() => {
      store
        .dispatch(Actions.GET_IRB_APPLICATION_SUBJECT, route.params.id)
        .then(() => {
          console.log("gg");
        });

      _stepperObj.value = StepperComponent.createInsance(
        verticalWizardRef.value as HTMLElement
      );

      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

    const createAccountSchema = [
      Yup.object({
        q1_1: Yup.number().min(1).label("How many subjects do you plan to enroll?"),
        q1_2: Yup.string().required().label("What is the age range of your targeted population (e.g., general adult population is 18+)"),
      }),
      Yup.object({
        
      }),
      Yup.object({
        q3_1: Yup.string().required().label("Inclusion Criteria"),
        q3_2: Yup.string().required().label("Exclusion Criteria"),
      }),
      Yup.object({
        q4_1: Yup.string().required().label("Subject Location"),
        q4_2: Yup.string().required().label("Subject Location Option Detail"),
      }),
      Yup.object({
        q5_2: Yup.string().when(
          'q5_1', {
            is: '1',
            then: Yup.string().required().label("Please explain the data that will be made available ")
          }
        ),
        q5_3: Yup.string().required().label("Where will the data be stored and for how long?"),
        q5_5: Yup.string().when(
          'q5_4', {
            is: '1',
            then: Yup.string().required().label("What are the identifiers that will be collected?")
          }
        ),
        q5_6: Yup.string().when(
          'q5_4', {
            is: '1',
            then: Yup.string().required().label("Who will have access to the identifiers?")
          }
        ),
        q5_7: Yup.string().when(
          'q5_4', {
            is: '1',
            then: Yup.string().required().label("When and how will you de-identify collected data")
          }
        ),
      }),
    ];

    const currentSchema = computed(() => {
      return createAccountSchema[currentStepIndex.value-1];
    });

    const { resetForm, handleSubmit } = useForm<IStep1 | IStep2 | IStep3>({
      validationSchema: currentSchema,
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    resetForm({
      values: {
        ...formData.value,
      },
    });

    const handleStep = handleSubmit((values) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      formData.value = {
        ...formData.value,
        ...values,
      };

      let data = currentSubject.value.data;
      const stepToUpdate = jumped.value === 1? previewStep.value: fromJumpled.value == 0? (currentStepIndex.value -1):currentStepIndex.value;

      if (stepToUpdate === 0) {
        data.numSubRecruited = formData.value.q1_1;
        data.researchSubject = formData.value.q1_2;
        data.isIncludeGannonStudents = formData.value.q1_3 == "1";

      } else if (stepToUpdate === 1) {
        if (data.population == null) {
           data.population = [];
        }
        for (var i = 0; i < 15 ; i++) {
          data.population[i] = {value: i, isChecked: false};
        }
        data.population[1].isChecked = formData.value.q2_1 == "1";
        data.population[2].isChecked = formData.value.q2_2 == "1";
        data.population[3].isChecked = formData.value.q2_3 == "1";
        data.population[4].isChecked = formData.value.q2_4 == "1";
        data.population[5].isChecked = formData.value.q2_5 == "1";
        data.population[6].isChecked = formData.value.q2_6 == "1";
        data.population[7].isChecked = formData.value.q2_7 == "1";
        data.population[8].isChecked = formData.value.q2_8 == "1";
        data.population[9].isChecked = formData.value.q2_9 == "1";
        data.population[10].isChecked = formData.value.q2_10 == "1";
        data.population[11].isChecked = formData.value.q2_11 == "1";
        data.population[12].isChecked = formData.value.q2_12 == "1";
        data.population[13].isChecked = formData.value.q2_13 == "1";
        data.population[14].isChecked = formData.value.q2_14 == "1";
        data.populationOther = formData.value.q2_populationOther;

      } else if (stepToUpdate === 2) {
        data.inclusionCriterial = formData.value.q3_1;
        data.exclusionCriterial = formData.value.q3_2;
      } else if (stepToUpdate == 3) {
        data.subjectLocation = formData.value.q4_1;
        data.subRecruitedOther = formData.value.q4_2;
      } else if (stepToUpdate == 4) {
        data.isAvailableEveryOne = formData.value.q5_1 == "1";
        data.confidentialityExplanation = formData.value.q5_2;
        data.subjectConfidentiality = formData.value.q5_3;
        data.isInformationIdentifiable = formData.value.q5_4 == "1";
        data.whatIdentifiers = formData.value.q5_5;
        data.whoHaveAccess = formData.value.q5_6;
        data.whenIdentifyData = formData.value.q5_7;
        
      }
      jumped.value = 0;
      fromJumpled.value = 0;
      if ([0, 1, 2, 3, 4, 5].indexOf(currentStepIndex.value) > -1) {
        const json = JSON.stringify(data);
        store
          .dispatch(Actions.POST_IRB_SUBJECT, json)
          .then(() => {
            if (currentStepIndex.value === 5) {
              toast.success("Information Saved", {
                timeout: 2000
              });
              router.push({
                  name: "edit-recruitment-factor",
                  params: { id: route.params.id },
                });
              
            }
            
            if (!_stepperObj.value) {
              return;
            }

            currentStepIndex.value++;
            _stepperObj.value?.goto(currentStepIndex.value);

          })
          .catch(() => {
            toast.error(store.getters.getIrbError, {
                timeout: 2000
              });
            
          });
      }
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const jumpToStep = (step) => {
      jumped.value = 0;
      fromJumpled.value = 1;
      previewStep.value = (currentStepIndex.value-1);

      if ((step +1) !== currentStepIndex.value) {
        jumped.value = 1;
      } 

      currentStepIndex.value = step;
      document.getElementById("buttonSubmit")?.click();
      /*if (step !== currentStepIndex.value) {
        console.log("goto step");
        currentStepIndex.value = step;
        _stepperObj.value?.goto(step);
       
      }*/
    };

    const formSubmit = (avoidReload) => {
      toast.success("Information Saved", {
                timeout: 2000
              });
              if (avoidReload == false) {
          window.location.reload();
        }
      
    };

    watchEffect(() => {
      const data = store.getters.currentSubject;
      if (data === null || data.data === undefined) return;
      // if (!_stepperObj.value) {
      //   return;
      // }

      // currentStepIndex.value = 2;

      // _stepperObj.value.goto(2);
    });

    watch(
      () => route.query,
      () => {
        console.log("watch");
        console.log(route.query);
      }
    );

    return {
      verticalWizardRef,
      previousStep,
      handleStep,
      formSubmit,
      totalSteps,
      currentStepIndex,
      jumpToStep,
      jumped,
    };
  },
});
